
export const referral = {
    addReferral: null,
    removeReferral: null,
    getAllUsers: null,
    getAllReferredUsers: null,
    getAllNonReferredUsers: null,
    getReferralAssociateUsers: null,
}